

import { Direction, Directionality } from '@angular/cdk/bidi';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export type MwcButtonGroupSize = 'large' | 'default' | 'small' | 'medium' | 'xl' | '2xl';

@Component({
  selector: 'mwc-button-group',
  exportAs: 'mwcButtonGroup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'mwc-btn-group',
    '[class.mwc-btn-group-lg]': `mwcSize === 'large'`,
    '[class.mwc-btn-group-sm]': `mwcSize === 'small'`,
    '[class.mwc-btn-group-rtl]': `dir === 'rtl'`
  },
  preserveWhitespaces: false,
  template: ` <ng-content></ng-content> `
})
export class MwcButtonGroupComponent implements OnDestroy, OnInit {
  @Input() mwcSize: MwcButtonGroupSize = 'default';

  dir: Direction = 'ltr';

  private destroy$ = new Subject<void>();

  constructor(@Optional() private directionality: Directionality) {}
  ngOnInit(): void {
    this.dir = this.directionality.value;
    this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe((direction: Direction) => {
      this.dir = direction;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
